module.exports = __webpack_public_path__ + "static/couponBackground-ff772efd5964e665a40e9f19cdaeb06c.png";